import type { ArticleCard } from 'types/capi/shared';

import ChevronIcon from '~/assets/icons/Chevron';

export type MetadataSize = 'sm' | 'md' | 'lg';
export type MetadataTheme = 'light' | 'dark';
export type TitleLines = 1 | 2 | 3 | 4;

type Props = {
  expanded?: boolean;
  hideCta?: boolean;
  isTextOverImage?: boolean;
  item: ArticleCard;
  size: MetadataSize;
  theme: MetadataTheme;
  titleLines?: TitleLines;
};

const TITLE_CLASSES: Record<MetadataSize, string> = {
  lg: 'text-card-lg',
  md: 'text-card-md',
  sm: 'text-card-sm'
};

const TITLE_CLAMP_CLASSES: Record<TitleLines, string> = {
  1: 'line-clamp-1',
  2: 'line-clamp-2',
  3: 'line-clamp-3',
  4: 'line-clamp-4'
};

const LINES_WITH_EXCERPT = 3;
const LINES_WITHOUT_EXCERPT = 4;
const READ_LABEL = 'Read more';

export default function Metadata({
  expanded,
  hideCta,
  isTextOverImage = false,
  item,
  size,
  theme,
  titleLines
}: Props) {
  const titleClass = TITLE_CLASSES[size];
  const titleColor = theme === 'dark' ? 'text-white' : 'text-black';
  const excerptColor = theme === 'dark' ? 'text-white' : 'text-grey-hide';
  const nudge = size === 'sm' ? '' : 'mt-1';
  const ctaColour = isTextOverImage ? 'text-white' : 'text-grey-hide';
  const clampClass =
    TITLE_CLAMP_CLASSES[
      titleLines ?? (expanded ? LINES_WITH_EXCERPT : LINES_WITHOUT_EXCERPT)
    ];

  return (
    <>
      <div className="flex flex-col gap-1">
        <h4 className="text-start text-xs text-grey-hide">
          {item.section ?? 'News'}
        </h4>
        <h3 className={`text-start ${titleClass} ${titleColor} ${clampClass}`}>
          {item.title}
        </h3>
      </div>

      {expanded && item.excerpt && (
        <p className={`${nudge} line-clamp-4 text-sm ${excerptColor}`}>
          {item.excerpt}
        </p>
      )}

      {!hideCta && (
        <div
          className={`${nudge} flex flex-row items-center gap-2 text-nowrap text-sm ${ctaColour}`}
        >
          <p className="leading-none">{READ_LABEL}</p>
          <div className="flex rotate-270 items-center justify-center">
            <ChevronIcon stroke="#A9A9A9" width="8px" height="8px" />
          </div>
        </div>
      )}
    </>
  );
}
